export enum Tool {
    Add = 1,
    Remove,
    Paint
}
